import { AlkLocalPersistence, fetchJsonFile, ILocalPersistence, isOpenFin } from '@alk/core';
import {
    ALL_AVAILABLE_INSTRUMENTS_SERVICE,
    AllAvailableInstrumentsService,
    IAllAvailableInstrumentsService,
} from './all-available-instruments';
import {
    AMEND_ORDER_ADAPTER_SERVICE,
    AmendOrderAdapterMock,
    AmendOrderAdapterService,
    IAmendOrderAdapterService,
} from './amend-order-adapter';
import {
    AMEND_ORDER_FROM_ANOTHER_USER_SERVICE,
    AmendOrderFromAnotherUserService,
    IAmendOrderFromAnotherUserService,
} from './amend-order-from-another-user';
import { AMEND_ORDER_SERVICE, AmendOrderService, IAmendOrderService } from './amend-order';
import {
    APP_BRANDING_CONFIG_SERVICE,
    AppBrandingConfigService,
    IAppBrandingConfigService,
} from './app-branding-config';
import { APP_CONFIGURATION } from '../constants';
import { APP_LIFECYCLE_SERVICE, AppLifecycleService, IAppLifecycleService } from './app-lifecycle';
import {
    ATTACHED_CLIENT_SERVICE,
    AttachedClientMock,
    AttachedClientService,
    IAttachedClientService,
} from './attached-client';
import {
    ATTACHED_FIRM_ADAPTER_SERVICE,
    AttachedFirmAdapterMock,
    AttachedFirmAdapterService,
    IAttachedFirmAdapterService,
} from './message-adapters/attached-firm-adapter';
import {
    AUTHENTICATION_FACTORY,
    AUTHENTICATION_SERVICE,
    authenticationFactory,
    AuthenticationMock,
    BasicAuthenticationService,
    IAuthenticationFactory,
    IAuthenticationService,
    PortalAuthenticationService,
} from './authentication';
import {
    BACKEND_SESSION_SERVICE,
    BackendSessionService,
    IBackendSessionService,
} from './backend-session';
import { BACKGROUND_SERVICE, NOTIFICATION_MUTATION_SERVICE, STOPPABLE_SERVICE } from '.';
import { BLOTTER_ADAPTER_SERVICE, BlotterAdapterMock, BlotterAdapterService, IBlotterAdapter } from './message-adapters/blotter-adapter';
import {
    BLOTTER_SERVICE,
    BlotterForwardService,
    BlotterPendingService,
    BlotterSpotService,
    IBlotterService,
} from './blotter';
import { BRANDING_SERVICE, BrandingService, IBrandingService } from './branding';
import {
    CANCEL_ORDER_ADAPTER_SERVICE,
    CancelOrderAdapterMock,
    CancelOrderAdapterService,
    ICancelOrderAdapterService,
} from './cancel-order-adapter';
import { CHANNEL_CONNECTOR_SERVICE, ChannelConnectorService, IChannelConnector } from './channel-connector';
import { CHANNEL_HUB_SERVICE, IChannelHub, OpenfinChannelHub, WorkerChannelHubService } from '@alk/channel-hub';
import { CLIENTS_SERVICE, ClientsService, IClientsService } from './clients';
import { COMMUNICATION_SERVICE, CommunicationService, ICommunicationService } from './communication';
import {
    CONFIGURATION_ADAPTER_SERVICE,
    ConfigurationAdapterMock,
    ConfigurationAdapterService,
    IConfigurationAdapterService,
} from './message-adapters/configuration-adapter';
import { CONFIGURATION_SERVICE, ConfigurationService, IConfigurationService } from './configuration';
import { container } from './container.ioc';
import { ContainerModule, decorate, injectable, interfaces as inversifyInterfaces } from 'inversify';
import {
    DATA_TRANSFER_SERVICE,
    DataTransferService,
    DataTransferServiceMock,
    IDataTransferService,
} from './data-transfer';
import { DELAYED_ACTION_SERVICE, DelayedActionService, IDelayedAction } from './delayed-action';
import { DETAILS_VIEW_SERVICE, DetailsViewService, IDetailsViewService } from './details-view';
import {
    DISCLAIMER_ADAPTER_SERVICE,
    DisclaimerAdapterMock,
    DisclaimerAdapterService,
    IDisclaimerAdapterService,
} from './message-adapters/disclaimer-adapter';
import { ESP_PRICE_SERVICE, EspPriceService } from './pricing/esp-price';
import {
    FEEDBACK_ADAPTER_SERVICE,
    FeedbackAdapterMock,
    FeedbackAdapterService,
    IFeedbackAdapterService,
} from './message-adapters/feedback-adapter';
import {
    FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE,
    FirmsAndInstrumentsAdapterService,
    FirmsAndInstrumentsAdapterServiceMock,
    IFirmsAndInstrumentsAdapterService,
} from './message-adapters/firms-and-instruments-adapter';
import {
    FORWARD_STREAM_ADAPTER_SERVICE,
    ForwardStreamAdapterMock,
    ForwardStreamAdapterService,
    IForwardStreamAdapterService,
} from './message-adapters/forward-stream-adapter';
import { FWD_PRICE_SERVICE, FwdPriceService } from './pricing/fwd-price';
import { GRID_ACTION_SERVICE, GridActionService, IGridActionService } from './grid-action';
import { GRID_CONTEXT_MENU_SERVICE, GridContextMenuService, IGridContextMenuService } from './grid-context-menu';
import { GRID_SCROLL_SERVICE, GridScrollService, IGridScrollService } from './grid-scroll';
import { HTTP_SERVICE, HttpService, IHttpService } from './http';
import {
    IAppsConfig,
    IBackgroundService,
    INotificationMutationService,
    IPriceService,
    IProvider,
    ISessionDisposable,
    IStateManagerService,
} from '../interfaces';
import { IInstrumentsService, INSTRUMENTS_SERVICE, InstrumentsService } from './instruments';
import {
    IKondorBlotterPositionService,
    IKondorBlotterService,
    KONDOR_BLOTTER_POSITION_SERVICE,
    KONDOR_BLOTTER_SERVICE, KondorBlotterPositionService,
    KondorBlotterService,
} from './blotter/kondor-blotter';
import { ILayoutPadsService, LAYOUT_PADS_SERVICE, LayoutPadsService } from './layout-pads';
import { ILimitsService, LIMITS_SERVICE, LimitsService } from './limits';
import {
    ILogAdapterService,
    LOG_ADAPTER_SERVICE,
    LogAdapterMock,
    LogAdapterService,
} from './message-adapters/log-adapter';
import { ILoggerService, LOGGER_SERVICE, LoggerService } from './logger';
import {
    IMonitoringWithBufferService,
    MONITORING_WITH_BUFFER_SERVICE,
    MonitoringWithBufferService,
} from './monitoring-with-buffer';
import { IMouseTrackingService, MOUSE_TRACKING_SERVICE, MouseTrackingService } from './mouse-tracking';
import { IMultipleDelayedActionService, MULTIPLE_DELAYED_ACTION_SERVICE, MultipleDelayedActionService } from './multiple-delayed-action';
import {
    INotificationMutationReadService,
    NOTIFICATION_MUTATION_READ_SERVICE,
    NotificationMutationReadService,
} from './notifications-services/notification-mutation-read';
import {
    INotificationMutationResolveService,
    NOTIFICATION_MUTATION_RESOLVE_SERVICE,
    NotificationMutationResolveService,
} from './notifications-services/notification-mutation-resolve';
import {
    INotificationsAdapter,
    NOTIFICATIONS_ADAPTER_SERVICE,
    NotificationsAdapterService,
    NotificationsAdapterServiceMock,
} from './message-adapters/notifications-adapter';
import {
    INotificationsCountService,
    NOTIFICATIONS_COUNT_SERVICE,
    NotificationsCountService,
} from './notifications-services/notifications-count';
import {
    INotificationsPoolService,
    NOTIFICATIONS_POOL_SERVICE,
    NotificationsPoolService,
} from './notifications-services/notifications-pool';
import {
    INotificationsResolveAdapterService,
    NOTIFICATIONS_RESOLVE_ADAPTER_SERVICE,
    NotificationsResolveAdapterMock,
    NotificationsResolveAdapterService,
} from './message-adapters/notifications-resolve-adapter';
import {
    INotificationsService,
    NOTIFICATIONS_SERVICE,
    NotificationsService,
} from './notifications-services/notifications';
import { IOrderCancelService, ORDER_CANCEL_SERVICE, OrderCancelService } from './order-cancel';
import { IOrdersAggregatorService, ORDERS_AGGREGATOR_SERVICE, OrdersAggregatorService } from './orders-aggregator';
import { IPadConfigService, PAD_CONFIG_SERVICE, PadConfigService } from './pad-config';
import { IPadOptionsService, PAD_OPTIONS_SERVICE, PadOptionsService } from './pad-options';
import {
    IPersistenceAdapterService,
    PERSISTENCE_ADAPTER_SERVICE,
    PersistenceAdapterMock,
    PersistenceAdapterService,
} from './message-adapters/persistence-adapter';
import { IPlaceOrder, PLACE_ORDER_SERVICE, PlaceOrderService } from './place-order';
import {
    IPlaceOrderAdapter,
    PLACE_ORDER_ADAPTER_SERVICE,
    PlaceOrderAdapterMock,
    PlaceOrderAdapterService,
} from './message-adapters/place-order-adapter';
import { IPriceProviderService, PRICE_PROVIDER_SERVICE, PriceProviderService } from './price-provider';
import { IRouterListenerService, ROUTER_LISTENER_SERVICE, RouterListenerService } from './router-listener';
import {
    ISelectedClientService,
    SELECTED_CLIENT_SERVICE,
    SelectedClientService,
} from './selected-client';
import {
    IServerSentEventsClientService,
    SERVER_SENT_EVENTS_CLIENT_SERVICE,
    ServerSentEventsClientMock,
    ServerSentEventsClientService,
} from '@alk/sse';
import {
    ISessionAdapterService,
    SESSION_ADAPTER_SERVICE,
    SessionAdapterMock,
    SessionAdapterService,
} from './message-adapters/session-adapter';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE, SessionLifecycleService } from './session-lifecycle';
import { ISessionPersistenceService, SESSION_PERSISTENCE_SERVICE } from './session-persistence';
import {
    ISoundNotificationsAdapterService,
    SOUND_NOTIFICATIONS_ADAPTER_SERVICE,
    SoundNotificationsAdapterMock,
    SoundNotificationsAdapterService,
} from './message-adapters/sound-notifications-adapter';
import { ISpeedBumpService, SPEED_BUMP_SERVICE, SpeedBumpService } from './speed-bump';
import {
    ISpotStreamAdapterService,
    SPOT_STREAM_ADAPTER_SERVICE,
    SpotStreamAdapterMock,
    SpotStreamAdapterService,
} from './message-adapters/spot-stream-adapter';
import {
    ISSEForKondorBlotterService,
    SSE_FOR_KONDOR_BLOTTER_SERVICE,
    SSEForKondorBlotterMock,
    SSEForKondorBlotterService,
} from './sse-for-kondor-blotter';
import {
    ISSEForLimitsService,
    SSE_FOR_LIMITS_SERVICE,
    SSEForLimitsMock,
    SSEForLimitsService,
} from './sse-for-limits';
import {
    IStateOfKondorBlotterConnectionService,
    STATE_OF_KONDOR_BLOTTER_CONNECTION_SERVICE,
    StateOfKondorBlotterConnectionService,
} from './state-of-kondor-blotter-connection';
import { ISubscriptionPoolingService, SUBSCRIPTION_POOLING_SERVICE, SubscriptionPoolingService } from './pricing/subscription-pooling';
import {
    ITenorResolveAdapterService,
    TENOR_RESOLVE_ADAPTER_SERVICE,
    TenorResolveAdapterMock,
    TenorResolveAdapterService,
} from './message-adapters/tenor-resolve-adapter';
import { ITenorResolveService, TENOR_RESOLVE_SERVICE, TenorResolveService } from './tenor-resolve';
import { IThemeService, THEME_SERVICE, ThemeService } from './theme';
import {
    ITradingQuantitiesService,
    TRADING_QUANTITIES_SERVICE,
    TradingQuantitiesService,
} from './trading-quantities';
import {
    ITradingSettingsAdapterService,
    TRADING_SETTINGS_ADAPTER_SERVICE,
    TradingSettingsAdapterMock,
    TradingSettingsAdapterService,
} from './trading-settings-adapter';
import {
    ITradingSettingsProviderService,
    TRADING_SETTINGS_PROVIDER_SERVICE,
    TradingSettingsProviderService,
} from './trading-settings-provider';
import {
    ITradingSettingsService,
    TRADING_SETTINGS_SERVICE,
    TradingSettingsService,
} from './trading-settings';
import { LOCAL_PERSISTENCE_SERVICE } from './symboles.ioc';
import { NotificationMutationNewService } from './notifications-services/notification-mutation-new';
import { NOTIFICATIONS_READ_SAVE_SERVICE, NotificationsReadSaveService } from './notifications-services/notifications-read-save';
import { OFX_CONFIG } from '../helpers/app-config';
import { SESSION_STATE_SERVICE, SessionStateService } from './session-state';
import { SessionPersistenceService } from './session-persistence/session-persistence.service';
import { SOUND_NOTIFICATIONS_SERVICE, SoundNotificationsService } from './sound-notifications';

decorate(injectable(), ServerSentEventsClientService);

interface INewable<T> {
    new (...args: Array<unknown>): T;
}

const bindToGroupByInterface = <IOrigin>(originIdentifier: symbol | string) =>
    (bind: inversifyInterfaces.Bind) =>
        (identifier: symbol) =>
            <IMain>(service: INewable<IMain> & INewable<IOrigin>): void => {
                bind<IMain>(service).toSelf().inSingletonScope();
                bind<IMain>(identifier).toService(service);
                bind<IOrigin>(originIdentifier).toService(service);
            };

const communicationDependencies = new ContainerModule((bind) => {
    if (OFX_CONFIG.MOCK) {
        bind<IDataTransferService>(DATA_TRANSFER_SERVICE).to(DataTransferServiceMock);
        bind<IServerSentEventsClientService>(SERVER_SENT_EVENTS_CLIENT_SERVICE)
            .to(ServerSentEventsClientMock)
            .inTransientScope();
        bind<ISSEForKondorBlotterService>(SSE_FOR_KONDOR_BLOTTER_SERVICE)
            .to(SSEForKondorBlotterMock);
        bind<ISSEForLimitsService>(SSE_FOR_LIMITS_SERVICE)
            .to(SSEForLimitsMock);
    } else {
        bind<IDataTransferService>(DATA_TRANSFER_SERVICE).to(DataTransferService);
        bind<IServerSentEventsClientService>(SERVER_SENT_EVENTS_CLIENT_SERVICE)
            .to(ServerSentEventsClientService)
            .inTransientScope();
        bind<ISSEForKondorBlotterService>(SSE_FOR_KONDOR_BLOTTER_SERVICE)
            .to(SSEForKondorBlotterService);
        bind<ISSEForLimitsService>(SSE_FOR_LIMITS_SERVICE)
            .to(SSEForLimitsService);
    }

    bind<ICommunicationService>(COMMUNICATION_SERVICE).to(CommunicationService);
});

const messageAdaptersDependencies = new ContainerModule((bind) => {

    const bindContext = bindToGroupByInterface<ISessionDisposable>(STOPPABLE_SERVICE)(bind);

    if (OFX_CONFIG.MOCK) {
        console.log('%cSERVICEs ARE MOCKED', 'background: black; color: deepskyblue');

        bind<IPersistenceAdapterService>(PERSISTENCE_ADAPTER_SERVICE).to(PersistenceAdapterMock);
        bindContext(FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE)<IFirmsAndInstrumentsAdapterService>(FirmsAndInstrumentsAdapterServiceMock);
        bindContext(SPOT_STREAM_ADAPTER_SERVICE)<ISpotStreamAdapterService>(SpotStreamAdapterMock);
        bind<IPlaceOrderAdapter>(PLACE_ORDER_ADAPTER_SERVICE).to(PlaceOrderAdapterMock);
        bind<IBlotterAdapter>(BLOTTER_ADAPTER_SERVICE).to(BlotterAdapterMock);
        bind<INotificationsAdapter>(NOTIFICATIONS_ADAPTER_SERVICE).to(NotificationsAdapterServiceMock);
        bindContext(FORWARD_STREAM_ADAPTER_SERVICE)<IForwardStreamAdapterService>(ForwardStreamAdapterMock);
        bindContext(TENOR_RESOLVE_ADAPTER_SERVICE)<ITenorResolveAdapterService>(TenorResolveAdapterMock);
        bind<INotificationsResolveAdapterService>(NOTIFICATIONS_RESOLVE_ADAPTER_SERVICE).to(NotificationsResolveAdapterMock);
        bind<ILogAdapterService>(LOG_ADAPTER_SERVICE).to(LogAdapterMock);
        bind<ICancelOrderAdapterService>(CANCEL_ORDER_ADAPTER_SERVICE).to(CancelOrderAdapterMock);
        bind<IAmendOrderAdapterService>(AMEND_ORDER_ADAPTER_SERVICE).to(AmendOrderAdapterMock);
        bind<ITradingSettingsAdapterService>(TRADING_SETTINGS_ADAPTER_SERVICE).to(TradingSettingsAdapterMock);
        bind<IFeedbackAdapterService>(FEEDBACK_ADAPTER_SERVICE).to(FeedbackAdapterMock);
        bind<IConfigurationAdapterService>(CONFIGURATION_ADAPTER_SERVICE).to(ConfigurationAdapterMock);
        bind<ISessionAdapterService>(SESSION_ADAPTER_SERVICE).to(SessionAdapterMock);
        bind<IAttachedFirmAdapterService>(ATTACHED_FIRM_ADAPTER_SERVICE).to(AttachedFirmAdapterMock);
        bind<IAttachedClientService>(ATTACHED_CLIENT_SERVICE).to(AttachedClientMock);
        bind<IDisclaimerAdapterService>(DISCLAIMER_ADAPTER_SERVICE).to(DisclaimerAdapterMock);
        bind<ISoundNotificationsAdapterService>(SOUND_NOTIFICATIONS_ADAPTER_SERVICE).to(SoundNotificationsAdapterMock);
    } else {
        bind<IPersistenceAdapterService>(PERSISTENCE_ADAPTER_SERVICE).to(PersistenceAdapterService);
        bindContext(SPOT_STREAM_ADAPTER_SERVICE)<ISpotStreamAdapterService>(SpotStreamAdapterService);
        bind<IPlaceOrderAdapter>(PLACE_ORDER_ADAPTER_SERVICE).to(PlaceOrderAdapterService);
        bind<IBlotterAdapter>(BLOTTER_ADAPTER_SERVICE).to(BlotterAdapterService);
        bind<INotificationsAdapter>(NOTIFICATIONS_ADAPTER_SERVICE).to(NotificationsAdapterService);
        bindContext(FORWARD_STREAM_ADAPTER_SERVICE)<IForwardStreamAdapterService>(ForwardStreamAdapterService);
        bind<IFirmsAndInstrumentsAdapterService>(FIRMS_AND_INSTRUMENTS_ADAPTER_SERVICE).to(FirmsAndInstrumentsAdapterService);
        bindContext(TENOR_RESOLVE_ADAPTER_SERVICE)<ITenorResolveAdapterService>(TenorResolveAdapterService);
        bind<INotificationsResolveAdapterService>(NOTIFICATIONS_RESOLVE_ADAPTER_SERVICE).to(NotificationsResolveAdapterService);
        bind<ILogAdapterService>(LOG_ADAPTER_SERVICE).to(LogAdapterService);
        bind<ICancelOrderAdapterService>(CANCEL_ORDER_ADAPTER_SERVICE).to(CancelOrderAdapterService);
        bind<IAmendOrderAdapterService>(AMEND_ORDER_ADAPTER_SERVICE).to(AmendOrderAdapterService);
        bind<ITradingSettingsAdapterService>(TRADING_SETTINGS_ADAPTER_SERVICE).to(TradingSettingsAdapterService);
        bind<IFeedbackAdapterService>(FEEDBACK_ADAPTER_SERVICE).to(FeedbackAdapterService);
        bind<IConfigurationAdapterService>(CONFIGURATION_ADAPTER_SERVICE).to(ConfigurationAdapterService);
        bind<ISessionAdapterService>(SESSION_ADAPTER_SERVICE).to(SessionAdapterService);
        bind<IAttachedFirmAdapterService>(ATTACHED_FIRM_ADAPTER_SERVICE).to(AttachedFirmAdapterService);
        bind<IAttachedClientService>(ATTACHED_CLIENT_SERVICE).to(AttachedClientService);
        bind<IDisclaimerAdapterService>(DISCLAIMER_ADAPTER_SERVICE).to(DisclaimerAdapterService);
        bind<ISoundNotificationsAdapterService>(SOUND_NOTIFICATIONS_ADAPTER_SERVICE).to(SoundNotificationsAdapterService);
    }
});

const appDependencies = new ContainerModule((bind) => {
    bind<IRouterListenerService>(ROUTER_LISTENER_SERVICE).to(RouterListenerService);
    bind<IMouseTrackingService>(MOUSE_TRACKING_SERVICE).to(MouseTrackingService).inTransientScope();
    bind<IPriceProviderService>(PRICE_PROVIDER_SERVICE).to(PriceProviderService).inTransientScope();
    bind<IPadConfigService>(PAD_CONFIG_SERVICE).to(PadConfigService).inTransientScope();
    bind<IDelayedAction>(DELAYED_ACTION_SERVICE).to(DelayedActionService).inTransientScope();
    bind<IMultipleDelayedActionService>(MULTIPLE_DELAYED_ACTION_SERVICE).to(MultipleDelayedActionService).inTransientScope();
    bind<IStateManagerService>(SESSION_STATE_SERVICE).to(SessionStateService);
    bind<ISessionPersistenceService>(SESSION_PERSISTENCE_SERVICE).to(SessionPersistenceService);
    bind<ISessionLifecycle>(SESSION_LIFECYCLE_SERVICE).to(SessionLifecycleService);
    bind<IAppLifecycleService>(APP_LIFECYCLE_SERVICE).to(AppLifecycleService);
    bind<IAppBrandingConfigService>(APP_BRANDING_CONFIG_SERVICE).to(AppBrandingConfigService);
    bind<IBrandingService>(BRANDING_SERVICE).to(BrandingService);
    bind<IThemeService>(THEME_SERVICE).to(ThemeService);
    bind<ILoggerService>(LOGGER_SERVICE).to(LoggerService);
    bind<ILayoutPadsService>(LAYOUT_PADS_SERVICE).to(LayoutPadsService);
    bind<IMonitoringWithBufferService>(MONITORING_WITH_BUFFER_SERVICE).to(MonitoringWithBufferService);
    bind<IGridScrollService>(GRID_SCROLL_SERVICE).to(GridScrollService);
    bind<IGridContextMenuService>(GRID_CONTEXT_MENU_SERVICE).to(GridContextMenuService);
    bind<IGridActionService>(GRID_ACTION_SERVICE).to(GridActionService);
    bind<IConfigurationService>(CONFIGURATION_SERVICE).to(ConfigurationService);
    bind<IStateOfKondorBlotterConnectionService>(STATE_OF_KONDOR_BLOTTER_CONNECTION_SERVICE)
        .to(StateOfKondorBlotterConnectionService);
    bind<IAllAvailableInstrumentsService>(ALL_AVAILABLE_INSTRUMENTS_SERVICE)
        .to(AllAvailableInstrumentsService);

    if (!OFX_CONFIG.IS_STANDALONE) {

        bind<IChannelConnector>(CHANNEL_CONNECTOR_SERVICE).to(ChannelConnectorService);
        if (isOpenFin()) {
            bind<IProvider<IChannelHub>>(CHANNEL_HUB_SERVICE).toProvider(() => {
                let singleton: IChannelHub = null;
                return async () => {
                    if (!Boolean(singleton)) {
                        singleton = new OpenfinChannelHub();
                    }
                    return singleton;
                };
            });
        } else {
            bind<IProvider<IChannelHub>>(CHANNEL_HUB_SERVICE).toProvider(() => {
                let singleton: IChannelHub = null;
                return async () => {
                    if (!Boolean(singleton)) {
                        const comApiIframeURL = (await fetchJsonFile<IAppsConfig>(APP_CONFIGURATION))
                            .services.find(service => service.id === 'com-api-sharedworker').endpoint;
                        singleton = new WorkerChannelHubService(comApiIframeURL) as IChannelHub;
                    }
                    return singleton;
                };
            },
            );
        }
    }
    bind<ITradingQuantitiesService>(TRADING_QUANTITIES_SERVICE).to(TradingQuantitiesService);
});

const bussinessLogicServices = new ContainerModule((bind) => {
    bind<ISubscriptionPoolingService>(SUBSCRIPTION_POOLING_SERVICE).to(SubscriptionPoolingService);
    bind<IPriceService>(ESP_PRICE_SERVICE).to(EspPriceService).inTransientScope();
    bind<IPriceService>(FWD_PRICE_SERVICE).to(FwdPriceService).inTransientScope();
    bind<IClientsService>(CLIENTS_SERVICE).to(ClientsService);
    bind<IPlaceOrder>(PLACE_ORDER_SERVICE).to(PlaceOrderService);
    bind<ISelectedClientService>(SELECTED_CLIENT_SERVICE).to(SelectedClientService);

    const bindStopableContext = bindToGroupByInterface<ISessionDisposable>(STOPPABLE_SERVICE)(bind);

    bindStopableContext(INSTRUMENTS_SERVICE)<IInstrumentsService>(InstrumentsService);

    bind<IOrdersAggregatorService>(ORDERS_AGGREGATOR_SERVICE).to(OrdersAggregatorService);
    bind<IBlotterService>(BLOTTER_SERVICE)
        .to(BlotterSpotService)
        .whenTargetNamed('spot');
    bind<IBlotterService>(BLOTTER_SERVICE)
        .to(BlotterForwardService)
        .whenTargetNamed('forward');
    bind<IBlotterService>(BLOTTER_SERVICE)
        .to(BlotterPendingService)
        .whenTargetNamed('pending');

    bind<IKondorBlotterService>(KONDOR_BLOTTER_SERVICE).to(KondorBlotterService);
    bind<IKondorBlotterPositionService>(KONDOR_BLOTTER_POSITION_SERVICE).to(KondorBlotterPositionService);

    bindStopableContext(NOTIFICATIONS_SERVICE)<INotificationsService>(NotificationsService);

    bindStopableContext(NOTIFICATIONS_POOL_SERVICE)<INotificationsPoolService>(NotificationsPoolService);

    bind<INotificationsCountService>(NOTIFICATIONS_COUNT_SERVICE).to(NotificationsCountService);

    bind<INotificationMutationReadService>(NotificationMutationReadService).toSelf().inSingletonScope();
    bind<INotificationMutationReadService>(NOTIFICATION_MUTATION_READ_SERVICE).toService(NotificationMutationReadService);
    bind<INotificationMutationService>(NOTIFICATION_MUTATION_SERVICE).toService(NotificationMutationReadService);

    bind<NotificationMutationNewService>(NotificationMutationNewService).toSelf().inSingletonScope();
    bind<INotificationMutationService>(NOTIFICATION_MUTATION_SERVICE).toService(NotificationMutationNewService);

    bind<INotificationMutationResolveService>(NotificationMutationResolveService).toSelf().inSingletonScope();
    bind<INotificationMutationResolveService>(NOTIFICATION_MUTATION_RESOLVE_SERVICE).toService(NotificationMutationResolveService);
    bind<INotificationMutationService>(NOTIFICATION_MUTATION_SERVICE).toService(NotificationMutationResolveService);

    bind<ITenorResolveService>(TENOR_RESOLVE_SERVICE).to(TenorResolveService);

    const bindBackgroundContext = bindToGroupByInterface<IBackgroundService>(BACKGROUND_SERVICE)(bind);
    bindBackgroundContext(NOTIFICATIONS_READ_SAVE_SERVICE)(NotificationsReadSaveService);
    bindBackgroundContext(SOUND_NOTIFICATIONS_SERVICE)(SoundNotificationsService);

    bind<IPadOptionsService>(PAD_OPTIONS_SERVICE).to(PadOptionsService);
    bind<IOrderCancelService>(ORDER_CANCEL_SERVICE).to(OrderCancelService);
    bind<IAmendOrderService>(AMEND_ORDER_SERVICE).to(AmendOrderService);
    bind<IAmendOrderFromAnotherUserService>(AMEND_ORDER_FROM_ANOTHER_USER_SERVICE)
        .to(AmendOrderFromAnotherUserService);

    bind<ITradingSettingsService>(TRADING_SETTINGS_SERVICE).to(TradingSettingsService);
    bind<ITradingSettingsProviderService>(TRADING_SETTINGS_PROVIDER_SERVICE).to(TradingSettingsProviderService);
    bind<IBackendSessionService>(BACKEND_SESSION_SERVICE).to(BackendSessionService);
    bind<ILimitsService>(LIMITS_SERVICE).to(LimitsService);
    bind<ISpeedBumpService>(SPEED_BUMP_SERVICE).to(SpeedBumpService);
    bind<IDetailsViewService>(DETAILS_VIEW_SERVICE).to(DetailsViewService);
});

const thirdPartyDependencies = new ContainerModule((bind) => {
    bind<ILocalPersistence>(LOCAL_PERSISTENCE_SERVICE).toConstantValue(AlkLocalPersistence);
});

const containerModules = [
    communicationDependencies,
    appDependencies,
    bussinessLogicServices,
    thirdPartyDependencies,
    messageAdaptersDependencies,
];

const authenticationDependencies = new ContainerModule((bind) => {
    bind<IHttpService>(HTTP_SERVICE).to(HttpService);

    if (OFX_CONFIG.MOCK) {
        bind<IAuthenticationService>(AUTHENTICATION_SERVICE).to(AuthenticationMock);
    } else {
        bind<IAuthenticationService>(AUTHENTICATION_SERVICE)
            .to(BasicAuthenticationService)
            .whenTargetNamed('form');
        bind<IAuthenticationService>(AUTHENTICATION_SERVICE)
            .to(PortalAuthenticationService)
            .whenTargetNamed('portal');
    }

    bind<IAuthenticationFactory>(AUTHENTICATION_FACTORY)
        .toFactory<IAuthenticationService>((context: inversifyInterfaces.Context) => {
        return () => authenticationFactory(context.container);
    });

    container.load(...containerModules);
});

/**
 * Flag to avoid duplicated service definition.
 */
let isLoaded = false;

export function init(): void {
    if (!isLoaded) {
        isLoaded = true;
        container.load(authenticationDependencies);
    }
}
